module.exports = __webpack_public_path__ + "img/wlpprs2.b541b725.png";